<template>
  <div>
    <div ref="quillEdit"></div>
    <input
      ref="quillEditImage"
      class="form-control d-none"
      type="file"
      accept="image/png, image/jpeg"
      @change="onFileChange()"
    />
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-better-table/dist/quill-better-table.css'

import Quill from 'quill'
import ImageResize from 'quill-image-resize-module'
import VideoResize from 'quill-video-resize-module2'
import QuillBetterTable from 'quill-better-table'

import { mapState, mapMutations, mapActions } from 'vuex'

const fontSizeArr = [
  '12px',
  '14px',
  '16px',
  '20px',
  '24px',
  '32px',
  '42px',
  '54px',
  '68px',
  '84px',
  '98px'
]

const Size = Quill.import('attributors/style/size')
Size.whitelist = fontSizeArr

Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/VideoResize', VideoResize)
Quill.register(
  {
    'modules/better-table': QuillBetterTable
  },
  true
)
Quill.register(Size, true)

const toolOptions = [
  // 標題
  // [{ header: [1, 2, 3, 4, 5, 6, false] }],
  // 字型大小
  [{ size: fontSizeArr }],
  // [{ size: ['small', false, 'large', 'huge'] }],
  // 加粗 斜體 下劃線 刪除線 文字顏色 文字背景顏色
  ['bold', 'italic', 'underline', 'strike', { color: [] }, { background: [] }],
  // 引用
  ['blockquote'],
  // 有序、無序列表
  [{ list: 'ordered' }, { list: 'bullet' }],
  // 上標/下標
  // [{ script: 'sub' }, { script: 'super' }],
  // 縮排
  [{ indent: '-1' }, { indent: '+1' }],
  // 文字方向
  // [{ direction: 'rtl' }],
  // 字型種類
  // [{ font: [] }],
  // 對齊方式
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' }
  ],
  // 連結、圖片、影片、表格
  ['link', 'image', 'video', 'table']
]

export default {
  props: ['value'],
  data () {
    return {
      quill: null,
      editorOption: {
        theme: 'snow',
        modules: {
          table: true, // disable table module
          'better-table': {
            operationMenu: {
              items: {
                unmergeCells: {
                  text: 'Another unmerge cells name'
                }
              }
            }
          },
          keyboard: {
            bindings: QuillBetterTable.keyboardBindings
          },
          imageResize: {
            displaySize: true
          },
          VideoResize: {
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
            tagName: 'iframe' // iframe | video
          },
          toolbar: {
            container: toolOptions,
            handlers: {
              image: () => {
                this.$refs.quillEditImage.click()
              },
              table: () => {
                this.quill.getModule('better-table').insertTable(3, 3)
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['token'])
  },
  watch: {
    value (data) {
      const vm = this
      if (!data) this.quill.clipboard.dangerouslyPasteHTML('')
      if (vm.quill && vm.quill.root.innerHTML !== data) {
        vm.quill.clipboard.dangerouslyPasteHTML(data)
      }
    }
  },
  methods: {
    ...mapMutations(['Loading', 'Loaded', 'AlertsInfo', 'Alerted']),
    ...mapActions(['uploadImage']),
    onFileChange () {
      const vm = this
      vm.uploadImage(vm.$refs.quillEditImage).then((value) => {
        if (value) {
          const range = vm.quill.getSelection()
          vm.quill.insertEmbed(range.index, 'image', value)
        }
      })
    }
  },
  mounted () {
    const vm = this
    vm.quill = new Quill(vm.$refs.quillEdit, vm.editorOption)
    vm.quill.on('text-change', () => {
      vm.$emit('input', vm.quill.root.innerHTML)
    })
  }
}
</script>

<style lang="scss">
.ql-editor {
  min-height: 300px;
}
.quill-editor iframe,
.quill-editor video {
  pointer-events: none;
}
.ql-snow {
  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  z-index: 999;
}
.qlbt-operation-menu {
  z-index: 1060;
}
</style>
